import React, { useMemo, lazy, memo, Suspense } from 'react';
import { brandConstants, appConfig } from 'brand-config';

import Field from 'core/components/form/form.v2';

const brandName = brandConstants.SHORT_NAME.toLowerCase();

export const BrandFormField = memo((props) => {
  const { riskType, state, id } = props;

  const fieldNameParts = id.split('.');

  const farmRiskBrandConfig = appConfig.farm[state]?.risks[riskType];

  const shouldHideCoverage = (coverageName) => farmRiskBrandConfig?.hiddenCoverages?.includes(coverageName);

  const fieldName = fieldNameParts[fieldNameParts.length - 1] || id;

  if (shouldHideCoverage(fieldName)) {
    return null;
  }

  const customComponentPath = farmRiskBrandConfig?.customFormComponentPaths?.[fieldName];

  if (!customComponentPath) {
    return <Field {...props} classes={{}} />;
  }

  const [risk, path] = customComponentPath.split('/');

  const CustomComponent = useMemo(() => {
    try {
      return lazy(() =>
        import(`./../../../common/components/brand-components/${brandName}/farm/${risk}/${state}/${path}.jsx`).catch(
          (error) => {
            console.warn(`Failed to load custom component: ${path}`, error);
            // Return a fallback component
            return { default: () => <Field {...props} classes={{}} /> };
          }
        )
      );
    } catch (error) {
      console.warn(`Failed to create lazy component: ${path}`, error);
      return () => <Field {...props} classes={{}} />;
    }
  }, [customComponentPath]);

  try {
    return (
      <Suspense fallback={<Field {...props} classes={{}} />}>
        <CustomComponent {...props} />
      </Suspense>
    );
  } catch (error) {
    console.warn(`Failed to render custom component: ${path}`, error);
    return <Field {...props} classes={{}} />;
  }
});
